import { render, staticRenderFns } from "./storeForm.vue?vue&type=template&id=28728a8d&"
import script from "./storeForm.vue?vue&type=script&lang=js&"
export * from "./storeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports